export const formDataCreator = (
  payload: FormData,
  farm: IFarmAddInfo | undefined,
) => {
  farm?.title && payload.append('title', farm?.title);
  payload.append('profile_type', 'farmer');
  farm?.cultivationGuid &&
    payload.append('cultivation_guid', farm?.cultivationGuid);
  farm?.existing && payload.append('existing', farm?.existing);
  farm?.existing_unit && payload.append('existing_unit', farm?.existing_unit);
  farm?.state && payload.append('state', farm?.state);
  farm?.city && payload.append('city', farm?.city);
  farm?.description && payload.append('description', farm?.description);
  farm?.hide_phone_number &&
    payload.append('hide_phone_number', `${farm?.hide_phone_number}`);
  farm?.type && payload.append('type', farm?.type);
  if (farm?.images && farm?.images?.length > 0) {
    const mainImage = farm.images?.find(x => x.isSelected)?.file;
    if (mainImage) {
      payload.append('main_image', mainImage);
    }
    farm?.images.map(item => payload.append('images', item.file));
  }
  if (farm?.deleted_images && farm?.deleted_images.length > 0) {
    farm?.deleted_images.map(item => payload.append('deleted_images', item));
  }
  return payload;
};
